import {
  getAccountPath,
  getCurrentPathnameFromState,
  getRegisterPath,
  getSettingsPath,
} from './shared';

export function getLogoutPath() {
  return getAccountPath() + '/sign-out';
}

export function getRegistrationBlockedPath() {
  return getRegisterPath() + '/not-available';
}

export function getForgotPasswordPath() {
  return getAccountPath() + '/help';
}

export function getResetPasswordPath() {
  return getAccountPath() + '/reset-password';
}

export function getBillingPath() {
  return getAccountPath() + '/billing';
}

export function pathMatchesAccount(pathname) {
  const regex = /^\/account.*$/;
  return regex.test(pathname);
}

export function getInfoPath() {
  return getSettingsPath() + '/info';
}

export function getDownloadAppPath() {
  return getSettingsPath() + '/download-app';
}

export function getSettingsUpgradePath() {
  return getSettingsPath() + '/upgrade';
}

export function getManageFamilyPlanPath() {
  return getSettingsPath() + '/family/manage';
}

export function getNotificationsPath() {
  return getSettingsPath() + '/notices';
}

export function getContentSettingsPath() {
  return getSettingsPath() + '/content';
}

export function getRedeemPath() {
  return getSettingsPath() + '/redeem';
}

export function getCodeRedemptionFlowPath(code) {
  return `/offer/${code}`;
}

export function getProfilePath(webname = '') {
  const profilePath = webname ? `/profile/${webname}` : '/profile';
  return profilePath;
}

export function isProfilePath(path) {
  return /^\/profile\/[^/]+$/.test(path);
}

export function getProfileThumbsPath() {
  return getProfilePath() + '/thumbs';
}

export function isOnSettingsUpgradePage(state) {
  const currentPath = getCurrentPathnameFromState(state);
  return currentPath === '/settings/upgrade';
}

export function isDesktopLandingPath(path) {
  return path === '/open';
}

export const UserProfilePaths = {
  profilePath: getProfilePath(),
  profileThumbsPath: getProfileThumbsPath(),
};
